import { BaleCreatePage } from '@/pages/facility/workflows/bale-create';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/bale-create')({
	component: BaleCreatePage,
});
